module.exports = __webpack_public_path__ + "static/media/cldc2012_program.8bc70806.pdf";